import React, { useContext, Component, useState } from 'react'
import Hero from '../components/Hero'
import styled from 'styled-components'
import { uuid } from 'uuidv4'
import { AuthContext } from '../context/AuthContext'
import axios from 'axios'
import Accordian from '../components/Accordian/Accordion'
import Tooltip from 'react-tooltip-lite'
import { AiFillInfoCircle } from 'react-icons/ai'
import isGithubUrl from 'is-github-url'

const Submission = () => {
  const [inputs, setInputs] = useState({
    repository: '',
    livesite: '',
    projectTitle: '404-error',
    feedback: '',
    // solutiontitle: '',
    date: new Date().toDateString(),
    id: uuid(),
  })
  const [fieldErrors, setFieldErrors] = useState({})
  const validationRules = {
    // repository: val => val && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val),
    repository: val => val && isGithubUrl(val),
    livesite: val => val && /netlify/.test(val),
    projectTitle: val => !!val,
    feedback: val => !!val,
    // solutiontitle: val => !!val || '',
    date: val => !!val,
    id: val => !!val,
  }
  const handleOnChange = event => {
    event.persist()
    setInputs(prev => ({
      ...prev,
      [event.target.id]: event.target.value,
    }))
  }
  const validate = () => {
    let errors = {}
    let hasErrors = false
    for (let key of Object.keys(inputs)) {
      errors[key] = !validationRules[key](inputs[key])
      hasErrors |= errors[key]
    }
    setFieldErrors(prev => ({ ...prev, ...errors }))
    return !hasErrors
  }
  const renderFieldError = field => {
    if (fieldErrors[field]) {
      return (
        <p className="errorMsg">
          Please enter a valid input. Check tooltip for help.
        </p>
      )
    }
  }
  // class Submission extends Component {
  const GitHubUser = useContext(AuthContext)
  //   const isAuthenticated = this.context.isAuthenticated
  const [serverState, setServerState] = useState({
    submitting: false,
    status: null,
  })
  const handleServerResponse = (ok, msg) => {
    setServerState({
      submitting: false,
      status: { ok, msg },
    })
    if (ok) {
      setInputs({
        repository: '',
        livesite: '',
        feedback: '',
        // solutiontitle: '',
      })
    }
  }
  const handleOnSubmit = event => {
    event.preventDefault()
    if (!validate()) {
      return
    }
    axios({
      method: 'POST',
      url: 'https://formspree.io/xqkywlkj',
      data: inputs,
    })
      .then(r => {
        handleServerResponse(true, 'Thanks!')
        window.location.href = 'https://frontendplayground.io/success'
      })
      .catch(r => {
        handleServerResponse(false, r.response.data.error)
      })
  }
  return (
    <Wrapper>
      <Hero />
      <section className="newsletter-page">
        <div className="page-center">
          <h2>Submit your project</h2>
          <h4>Please fill out the form fields</h4>
          <form onSubmit={handleOnSubmit} noValidate className="contact-form">
            <input
              type="hidden"
              name="date"
              id="date"
              value={new Date().toDateString()}
            />
            <label htmlFor="projectTitle">Project</label>

            <select
              name="projectTitle"
              id="projectTitle"
              className="form-control"
              onChange={handleOnChange}
              required
            >
              <option onChange={handleOnChange} value="404-error">
                404 Error
              </option>
              <option onChange={handleOnChange} value="sign-up-gym">
                Gym Sign Up
              </option>
              <option onChange={handleOnChange} value="snow-camp">
                Snow Camp
              </option>
              <option onChange={handleOnChange} value="sign-up-form">
                Sign Up Form
              </option>
              <option onChange={handleOnChange} value="scribe-agency">
                Scribe Agency
              </option>
              <option onChange={handleOnChange} value="quote-machine">
                Quote Machine
              </option>
              <option onChange={handleOnChange} value="sound-jam">
                Sound Jam
              </option>
              <option onChange={handleOnChange} value="sign-up">
                Simple Sign Up
              </option>
            </select>
            {renderFieldError('projectTitle')}
            {/* <label>Solution Title</label>
            <input
              type="text"
              id="solutiontitle"
              name="solutiontitle"
              value={inputs.solutiontitle}
              onChange={handleOnChange}
              placeholder="e.g. Responsive landing page using CSS Grid"
              className="form-control"
            />
            {renderFieldError('solutiontitle')} */}
            <div className="flex">
              <label>GitHub Repository URL</label>
              <Tooltip
                content="Check FAQ below for how to host code on GitHub"
                direction="right"
              >
                <AiFillInfoCircle className="tooltip" />
              </Tooltip>
            </div>
            <input
              type="text"
              id="repository"
              name="repository"
              className="form-control"
              onChange={handleOnChange}
              value={inputs.repository}
            />
            {renderFieldError('repository')}

            <input type="hidden" name="id" id="id" value={uuid()} />
            <div className="flex">
              <label>Netlify Live Site URL</label>
              <Tooltip
                content="Check FAQ below for how to deploy to Netlify"
                direction="right"
              >
                <AiFillInfoCircle className="tooltip" />
              </Tooltip>
            </div>
            <input
              type="text"
              id="livesite"
              name="livesite"
              className="form-control"
              onChange={handleOnChange}
              value={inputs.liveSite}
            />
            {renderFieldError('livesite')}
            {/* <label>Questions for the community (optional):</label> */}
            <label>Feedback</label>
            <textarea
              id="feedback"
              name="feedback"
              rows="5"
              className="form-control"
              // value={inputs.feedback}
              onChange={handleOnChange}
            />
            {renderFieldError('feedback')}
            {GitHubUser.isAuthenticated && (
              <button type="submit" className="btn form-control submit-btn">
                Submit solution
              </button>
            )}
            {!GitHubUser.isAuthenticated && (
              <div className="btn form-control submit-btn">
                Login to Submit Solution
              </div>
            )}
          </form>
        </div>
        <AccordianWrapper>
          <Accordian
            title="How do I put my code up on GitHub?"
            content="If you are new to GitHub this is a great place to get started: https://bit.ly/github-in-twenty. Or, check the readme.MD that you downloaded with the project for further learning resources"
          />
          <Accordian
            title="How do I put deploy my code with Netlify?"
            content="While there are a lot of options to deploy your site live on the web. Netlify offers and incredibley pain free, and cost free, experience: https://bit.ly/deploy-with-netlify"
          />
        </AccordianWrapper>
      </section>
    </Wrapper>
  )
}

const LoginWrapper = styled.div`
  max-width: 500px;
  margin: 15px auto;
`

const AccordianWrapper = styled.div`
  width: 100vw;
`

const Wrapper = styled.div`
  .tooltip {
    display: none;
  }
  .errorMsg {
    max-width: 500;
  }

  @media (min-width: 768px) {
    .tooltip {
      display: flex;
      height: 14px;
      color: #102a42;
    }
    .errorMsg {
      max-width: 250px;
    }
  }
`

export default Submission
